import ImageWithText from 'components/common/ImageWithText';
import { TWishlistPrize } from 'stores/UserStore';
import Heart from '../../svg/Heart40.svg';
import HeartFilled from '../../svg/Heart40Filled.svg';
import styles from './YourWishlist.module.css';

const WishlistPrize = ({
  prize,
  favourited = true,
  unfavouritePrize,
}: {
  prize: TWishlistPrize;
  favourited: boolean;
  unfavouritePrize: () => void;
}) => (
  <ImageWithText
    imageSrc={prize.heroImageLocation}
    title={prize.title}
    imageOverlayChildren={
      <div className={styles.wishlistImageOverlay}>
        <button className={styles.favourited} onClick={unfavouritePrize}>
          {favourited ? <HeartFilled /> : <Heart />}
        </button>
      </div>
    }
  />
);

export default WishlistPrize;
